export { MAGIC_SIGN_PAGE_SIZE as GLOBAL_MAGIC_SIGN_PAGE_SIZE } from '../../common/MagicSign/constants';

export const GLOBAL_MAGIC_SIGN_TABS = {
    MAGIC_UPLOAD: 'magicUpload',
    MAGIC_SIGN: 'magicSign',
} as const;

export type GlobalMagicSignTab = (typeof GLOBAL_MAGIC_SIGN_TABS)[keyof typeof GLOBAL_MAGIC_SIGN_TABS];
